import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { ChallengeDigitalIntensityAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-digital-intensity.aggregate.root';
import { GetAccountMetricsInsightsAveragesResponseDto } from '../../../interface/dtos/challenge-insights/get-account-metrics-insights-averages.response.dto';

export class ChallengeDigitalIntensityAggregateRootMapper
  implements
    Omit<
      Mapper<
        ChallengeDigitalIntensityAggregateRoot,
        GetAccountMetricsInsightsAveragesResponseDto
      >,
      'toDomain'
    >
{
  toResponse(
    entity: ChallengeDigitalIntensityAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return ChallengeDigitalIntensityAggregateRootMapper.toResponse(entity);
  }
  static toResponse(
    entity: ChallengeDigitalIntensityAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return {
      deviation: `${formatDeviation(Math.round(entity.deviationPercentage))}`,
      beforeValue: Math.round(entity.beforeValue),
      afterValue: Math.round(entity.value),
      beforeFormattedValue: Math.round(entity.beforeValue).toString(),
      afterFormattedValue: Math.round(entity.value).toString(),
      averageDeviation: `${formatDeviation(
        Math.round(entity.averageDeviationPercentage)
      )}`,
      beforeAverage: Math.round(entity.beforeAverage),
      afterAverage: Math.round(entity.average),
      beforeFormattedAverage: String(Math.round(entity.beforeAverage)),
      afterFormattedAverage: String(Math.round(entity.average)),
    };
  }
}
